import React from 'react'
import { useLocation } from 'react-router-dom'

function HeaderDark() {
  const { pathname } = useLocation()

  const navClass = (path) => {
    if (path === '/') return pathname === '/' ? 'nav-link active' : 'nav-link'
    if (path === '/services') return pathname.startsWith('/services') || ['/webdev','/digital-marketing','/brand-strategy','/database-analysis','/consulting','/mobile-app'].includes(pathname) ? 'nav-link active' : 'nav-link'
    return pathname.startsWith(path) ? 'nav-link active' : 'nav-link'
  }

  return (
    <header className="header-sticky header-absolute" data-bs-theme="dark">
      <nav className="navbar navbar-expand-xl">
        <div className="container">

          {/* Logo */}
          <a className="navbar-brand me-0" href="/">
            <img className="light-mode-item navbar-brand-item" style={{ height: '60px' }} src="assets/images/logo-white.png" alt="logo" />
            <img className="dark-mode-item navbar-brand-item" style={{ height: '60px' }} src="assets/images/logo-white.png" alt="logo" />
          </a>

          {/* Nav links */}
          <div className="navbar-collapse collapse" id="navbarCollapseDark">
            <ul className="navbar-nav navbar-nav-scroll dropdown-hover mx-auto">

              <li className="nav-item">
                <a className={navClass('/')} href="/">Home</a>
              </li>

              <li className="nav-item">
                <a className={navClass('/about')} href="/about">About Us</a>
              </li>

              <li className="nav-item">
                <a className={navClass('/portfolio')} href="/portfolio">Portfolio</a>
              </li>
              <li className="nav-item">
                <a className={navClass('/services')} href="/services">Services</a>
              </li>

              <li className="nav-item">
                <a className={navClass('/contact')} href="/contact">Contact us</a>
              </li>

            </ul>
          </div>

          {/* Right buttons */}
          <ul className="nav align-items-center dropdown-hover ms-sm-2">

           

           
            {/* Mobile toggler */}
            <li className="nav-item">
              <button className="navbar-toggler ms-sm-3 p-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapseDark" aria-controls="navbarCollapseDark" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-animation">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </li>

          </ul>
        </div>
      </nav>
    </header>
  )
}

export default HeaderDark
